module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.myModal = true
      }
    }
  }, [_vm._v("Launch demo modal")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.largeModal = true
      }
    }
  }, [_vm._v("Launch large modal")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.smallModal = true
      }
    }
  }, [_vm._v("Launch small modal")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.primaryModal = true
      }
    }
  }, [_vm._v("Launch primary modal")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.successModal = true
      }
    }
  }, [_vm._v("Launch success modal")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.warningModal = true
      }
    }
  }, [_vm._v("Launch warning modal")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dangerModal = true
      }
    }
  }, [_vm._v("Launch danger modal")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.infoModal = true
      }
    }
  }, [_vm._v("Launch info modal")])])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "title": "Modal title",
      "effect": "fade/zoom"
    },
    on: {
      "ok": function($event) {
        _vm.myModal = false
      }
    },
    model: {
      value: (_vm.myModal),
      callback: function($$v) {
        _vm.myModal = $$v
      },
      expression: "myModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])]), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  ")]), _vm._v(" "), _c('modal', {
    attrs: {
      "title": "Modal title",
      "large": "",
      "effect": "fade/zoom"
    },
    on: {
      "ok": function($event) {
        _vm.largeModal = false
      }
    },
    model: {
      value: (_vm.largeModal),
      callback: function($$v) {
        _vm.largeModal = $$v
      },
      expression: "largeModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])]), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  ")]), _vm._v(" "), _c('modal', {
    attrs: {
      "title": "Modal title",
      "small": "",
      "effect": "fade/zoom"
    },
    on: {
      "ok": function($event) {
        _vm.smallModal = false
      }
    },
    model: {
      value: (_vm.smallModal),
      callback: function($$v) {
        _vm.smallModal = $$v
      },
      expression: "smallModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])]), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  ")]), _vm._v(" "), _c('modal', {
    staticClass: "modal-primary",
    attrs: {
      "title": "Modal title",
      "effect": "fade/zoom"
    },
    on: {
      "ok": function($event) {
        _vm.primaryModal = false
      }
    },
    model: {
      value: (_vm.primaryModal),
      callback: function($$v) {
        _vm.primaryModal = $$v
      },
      expression: "primaryModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])]), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  ")]), _vm._v(" "), _c('modal', {
    staticClass: "modal-success",
    attrs: {
      "title": "Modal title",
      "effect": "fade/zoom"
    },
    on: {
      "ok": function($event) {
        _vm.successModal = false
      }
    },
    model: {
      value: (_vm.successModal),
      callback: function($$v) {
        _vm.successModal = $$v
      },
      expression: "successModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])]), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  ")]), _vm._v(" "), _c('modal', {
    staticClass: "modal-warning",
    attrs: {
      "title": "Modal title",
      "effect": "fade/zoom"
    },
    on: {
      "ok": function($event) {
        _vm.warningModal = false
      }
    },
    model: {
      value: (_vm.warningModal),
      callback: function($$v) {
        _vm.warningModal = $$v
      },
      expression: "warningModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])]), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  ")]), _vm._v(" "), _c('modal', {
    staticClass: "modal-danger",
    attrs: {
      "title": "Modal title",
      "effect": "fade/zoom"
    },
    on: {
      "ok": function($event) {
        _vm.dangerModal = false
      }
    },
    model: {
      value: (_vm.dangerModal),
      callback: function($$v) {
        _vm.dangerModal = $$v
      },
      expression: "dangerModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])]), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  ")]), _vm._v(" "), _c('modal', {
    staticClass: "modal-info",
    attrs: {
      "title": "Modal title",
      "effect": "fade/zoom"
    },
    on: {
      "ok": function($event) {
        _vm.infoModal = false
      }
    },
    model: {
      value: (_vm.infoModal),
      callback: function($$v) {
        _vm.infoModal = $$v
      },
      expression: "infoModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])]), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Bootstrap Modals\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d9bc03e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/coreui/Modals.vue
// module id = 1019
// module chunks = 1